import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Loader from "../../../core/common/selfLoder";
import { all_routes } from "../../router/all_routes";
import useApi from "../../../core/customhook/useApi";
import dayjs from "dayjs";

const LeaveGrid = [
  {
    name: "Self Leave Dashboard",
    logo: "../assets/img/dashboard/Leavedashboard.png",
    Link: "/self-leave-dashboard",
  },
  {
    name: "Leave Application",
    logo: "../assets/img/dashboard/Leave-application.png",
    Link: "/leave-application",
  },
  {
    name: "Leave Details",
    logo: "../assets/img/dashboard/Leave-details.png",
    Link: "/leave-details",
  },
  {
    name: "Leave Balance",
    logo: "../assets/img/dashboard/Leave-balalnce.png",
    Link: "/leave-balance",
  },
  {
    name: "Leave Calender",
    logo: "../assets/img/dashboard/Leave-calender.png",
    Link: "/leave-calender",
  },
];

const SelfLeaveGrid = () => {
  const getCurrentFinancialYear = () => {
    const currentYear = new Date().getFullYear(); // e.g., 2025
    const nextYearShort = (currentYear + 1).toString().slice(-2); // "26"
    return `${currentYear}-${nextYearShort}`;
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());
  const [loading, setLoading] = useState(true);

  const {
    data: leave_Balance_data,
    loading: leave_balamce_loading,
    error: leave_balance_error,
  } = useApi("/api/view-leave-balance", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year],
  });

  const summaryData = {
    leaveBalance: "18.0 Days",
    leavesApplied: 8,
    pendingApprovals: 1,
    upcomingLeave: "01 May 2026",
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);
  return (
    <>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Work & Operations</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Leave</li>
                  <li className="breadcrumb-item active">
                    <Link to={all_routes.selfGrid} aria-current="page">
                      Self Leave
                    </Link>
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          {/* <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Self Leave</h5>
            </div>
            <div className="card-body">
              <div className="row h-100">
                {LeaveGrid.map((card, index) => (
                  <div
                    key={index}
                    className="col-6 col-sm-4 col-md-3 mb-4 d-flex"
                  >
                    <Link to={card.Link} className="w-100">
                      <div className="card h-100 shadow-sm px-2 py-3 px-md-4 px-md-4 d-flex flex-column align-items-center justify-content-center text-center">
                        <img
                          src={card.logo}
                          alt={card.name}
                          className="mb-3"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                          }}
                        />
                        <h5 className="mb-0">{card.name}</h5>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div> */}

          <div className="card mb-4">
            <div className="card-header">
              <h5>Leave Management</h5>
              <h5 className="mt-1">Self Leave</h5>
            </div>

            <div className="card-body">
              <div className="row text-center mb-4">
                {/* Leave Balance */}
                <div className="col mb-3">
                  <div className="border rounded p-3 h-100 d-flex align-items-center justify-content-center gap-3">
                    <div className="bg-info bg-opacity-10 p-3 rounded-circle">
                      <h6>{leave_Balance_data?.AvailableLeaves}</h6>
                    </div>
                    <div className="text-start">
                      <h6 className="mb-1">Leave Balance</h6>
                      <h5 className="text-primary mb-0">
                        {leave_Balance_data?.AvailableLeaves} Days
                      </h5>
                    </div>
                  </div>
                </div>

                {/* Leaves Applied */}
                <div className="col mb-3">
                  <div className="border rounded p-3 h-100 d-flex align-items-center justify-content-center gap-3">
                    <div className="bg-info bg-opacity-10 p-3 rounded-circle">
                      <i
                        className="ti ti-send text-primary me-1"
                        style={{ fontSize: "25px", fontWeight: "600" }}
                      ></i>
                    </div>
                    <div className="text-start">
                      <h6 className="mb-1">Leaves Applied</h6>
                      <h5 className="mb-0">{leave_Balance_data?.TotalApply}</h5>
                    </div>
                  </div>
                </div>

                {/* Pending Approvals */}
                <div className="col mb-3">
                  <div className="border rounded p-3 h-100 d-flex align-items-center justify-content-center gap-3">
                    <div className="bg-info bg-opacity-10 p-3 rounded-circle">
                      <i
                        className="ti ti-clock text-primary me-1"
                        style={{ fontSize: "25px", fontWeight: "600" }}
                      ></i>
                    </div>
                    <div className="text-start">
                      <h6 className="mb-1">Pending Approvals</h6>
                      <h5 className="text-primary mb-0">
                        {leave_Balance_data?.UpcomingApproved || 0}
                      </h5>
                    </div>
                  </div>
                </div>

                {/* Upcoming Leave */}
                <div className="col mb-3">
                  <div className="border rounded p-3 h-100 d-flex align-items-center justify-content-center gap-3">
                    <div className="bg-info bg-opacity-10 p-3 rounded-circle">
                      <i
                        className="ti ti-calendar-check text-primary me-1"
                        style={{ fontSize: "25px", fontWeight: "600" }}
                      ></i>
                    </div>
                    <div className="text-start">
                      <h6 className="mb-1">Upcoming Leave</h6>
                      <h5 className="mb-0">
                        {leave_Balance_data?.upCommingLeave
                          ? dayjs(leave_Balance_data.upCommingLeave).format(
                              "DD MMMM YYYY",
                            )
                          : "-"}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>

              {/* 🔹 Action Buttons */}
              <div className="d-flex gap-3 flex-wrap">
                <Link to="/leave-application" className="btn btn-primary">
                  <i className="bi bi-plus-circle me-2"></i>
                  Apply Leave
                </Link>

                <Link to="/leave-calender" className="btn btn-outline-primary">
                  <i className="bi bi-calendar3 me-2"></i>
                  View Leave Calendar
                </Link>
              </div>
            </div>
          </div>

          {/* 🔹 Grid Section */}
          <div className="card">
            <div className="card-body">
              <div className="row h-100">
                {LeaveGrid.map((card, index) => (
                  <div key={index} className="col mb-4 d-flex">
                    <Link to={card.Link} className="w-100">
                      <div className="card h-100 shadow-sm px-3 py-4 d-flex flex-column align-items-center justify-content-center text-center">
                        <img
                          src={card.logo}
                          alt={card.name}
                          className="mb-3"
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "contain",
                          }}
                        />
                        <h6 className="mb-0">{card.name}</h6>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default SelfLeaveGrid;
